module.exports = __webpack_public_path__ + "img/c07_unitfireship_Normal_ua.ad6daa5e.webp";